<template>
  <IQOS :title="$t('regular_report.title')">
      <div class="iqos-comment mt-16" v-if="!is_active">
          {{ $t('regular_report.desc') }}
      </div>

      <div class="gap-row-xs mt-16" v-else>
        <div class="qrw-label-sm v1-grey-7-color bold">
            {{ $t('regular_report.select_period') }}
        </div>
        <BaseTabSwitcher class="w-100" fullWidth v-model="period" :tabs="[
            {
                text: $t('regular_report.daily'),
                value: 'daily'
            },
            {
                text: $t('regular_report.weekly'),
                value: 'weekly'
            },
            {
                text: $t('regular_report.monthly'),
                value: 'monthly'
            }
        ]"/>
        <BaseDivider color="v1-grey-4"/>
        <div class="qrw-label-sm v1-grey-7-color bold">
            {{ $t('regular_report.select_channel') }}
        </div>
        <SlideToggleRow v-model="channels.telegram">
             {{ $t('regular_report.channel_telegram') }}
        </SlideToggleRow>
        <SlideToggleRow v-model="channels.email">
             {{ $t('regular_report.channel_email') }}
        </SlideToggleRow>
      </div>

      <template #actions>
          <IQOSToggle v-model="is_active"/>
      </template>
  </IQOS>
</template>

<script>
import SlideToggleRow from "@/components/SlideToggleRow.vue"

export default {
    data() {
        return {
            is_active: false,
            period: 'weekly',
            channels: {
                telegram: false,
                email: true
            }
        }
    },
    components: {
        SlideToggleRow
    }
}
</script>

<style>

</style>